// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"16":"5ad3835b","70":"60bcf79c","284":"a38862c5","318":"8fec3da4","388":"0928dea9","401":"ee74d09c","440":"11eb426a","757":"7f8d2f50","887":"694f30c2"}[chunkId] + ".chunk.js";
};